module.exports = require("babel-runtime/core-js/json/stringify");